module.exports = __webpack_public_path__ + "img/abia.35e986dc.png";